import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000,
      background: '#FFFFFFee', backdropFilter: 'blur(8px)',
      borderTop: '1px solid #E2E8F0',
      padding: '10px 24px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
      fontSize: 13, color: '#64748B',
    }}>
      We use cookies to analyze site traffic.
      <button onClick={() => { localStorage.setItem('cookie_consent', 'true'); setVisible(false); }}
        style={{ background: '#1B2B4B', color: '#FFFFFF', border: 'none', padding: '5px 14px', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
        OK
      </button>
    </div>
  );
}
